import { render, staticRenderFns } from "./GaDepartmentSelection.vue?vue&type=template&id=42163d7d&scoped=true&"
import script from "./GaDepartmentSelection.vue?vue&type=script&lang=ts&"
export * from "./GaDepartmentSelection.vue?vue&type=script&lang=ts&"
import style0 from "./GaDepartmentSelection.vue?vue&type=style&index=0&id=42163d7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42163d7d",
  null
  
)

export default component.exports